

interface EmailAlertProps {
  email: string;
  exists: boolean;
  isChecking: boolean;
  error: string | null;
  onSwitchToSignIn?: () => void;
}

/**
 * Composant d'alerte pour informer l'utilisateur si l'email existe déjà
 * Affiche uniquement une alerte quand l'email est déjà utilisé
 */
export const EmailAlert = ({ 
  email, 
  exists, 
  isChecking, 
  error, 
  onSwitchToSignIn 
}: EmailAlertProps) => {
  // Ne rien afficher si l'email est vide ou invalide
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return null;
  }

  // Ne rien afficher pendant la vérification
  if (isChecking) {
    return null;
  }

  // Ne rien afficher en cas d'erreur
  if (error) {
    return null;
  }

  // Affichage uniquement si l'email existe déjà
  if (exists) {
    return (
      <div className="mt-1">
        <p className="text-sm text-red-500">
          Cet email est déjà utilisé.{' '}
          {onSwitchToSignIn && (
            <button
              type="button"
              onClick={onSwitchToSignIn}
              className="text-red-500 hover:text-red-600 underline font-medium"
            >
              Se connecter
            </button>
          )}
        </p>
      </div>
    );
  }

  // Ne rien afficher si l'email est disponible
  return null;
};